export const loopNextDTO = {
  forApi: (step: any) => {
    return step;
  },
  forFlow: (step: any) => step, // this should nexer get called
};
